// extracted by mini-css-extract-plugin
export default {"container":"CautionPage_container__UhvRF"};